import { createPinia } from 'pinia';

const store = createPinia();

export default store;

// 模块统一导出
export * from './user';
